import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
	plugins: [createPersistedState()],
	state: {
		authentication: {
			token: null,
			user: null,
			loggedIn: false
		},
		settings: {
			darkMode: false,
			weekView: 'byDay'
		},
		modal: {
			open: false
		},
		plannings: [],
		social: {
			friends: [],
			friendRequests: []
		}
	},
	actions,
	mutations,
	getters
})
